import type {
  CloudinaryAsset,
  SanityImage,
} from '@bulknutrients/bulk-shared-lib/interfaces/Sanity';
import { calculateHeight } from '@bulknutrients/bulk-shared-lib/lib/images';
import { CustomImage } from '@components/Media/Image/Image';
import type { PortableTextTypeComponentProps } from '@portabletext/react';

export function ImageRenderer(
  props: PortableTextTypeComponentProps<SanityImage | CloudinaryAsset>
) {
  if (props.value.fullWidth) {
    const width = props.value.width ? Math.min(2500, props.value.width) : 2500;
    return (
      <CustomImage
        image={props.value}
        width={width}
        height={calculateHeight(width, props.value.ratio)}
      />
    );
  }

  const width = Math.min(300, props.value.width);
  return (
    <CustomImage
      image={props.value}
      width={width}
      height={calculateHeight(width, props.value.ratio)}
    />
  );
}
